<template lang="pug">
  v-app
    Header
    CookieConsent
    v-content
      transition-group(
        name="fade"
        mode="out-in"
      )
        router-view(key=1)
        FreshWidget(key=2)
    Footer
</template>

<script>
import { mapActions } from 'vuex';
import Cookies from 'js-cookie';
import Footer from '@/components/common/Footer.vue';
import Header from '@/components/common/Header.vue';
import bugsnagClient from './lib/bugsnag';

const CookieConsent = () => import('@/components/App/CookieConsent.vue');
const FreshWidget = () => import('@/components/common/FreshWidget.vue');

export default {
  name: 'App',
  mounted() {
    this.login();
    if (Cookies.get('user') !== undefined) {
      this.updateUserFromCookie();
      bugsnagClient.user = JSON.parse(Cookies.get('user'));
    }
    if (Cookies.get('driver') !== undefined) {
      this.updateDriverFromCookie();
    }
  },
  components: {
    CookieConsent,
    Footer,
    FreshWidget,
    Header,
  },
  methods: {
    ...mapActions([
      'login',
      'updateUserFromCookie',
      'updateDriverFromCookie',
    ]),
  },
};
</script>

<style lang="stylus" scoped>
.fade-enter-active, .fade-leave-active
  transition-duration 0.3s
  transition-property opacity
  transition-timing-function ease

.fade-enter, .fade-leave-active
  opacity 0
</style>
